<template>
  <ComboPicker
    :label="label"
    :orientation="orientation"
    strings="status,status;o"
    icon="mdi-skull"
    :value="value"
    @input="(v) => $emit('input', v)"
    :whenEmpty="orientation == 'horizontal' ? 'Todos os status' : '(Todos)'"
    types="grouped-items"
    :items="allItems"
  />
</template>

<script>
import ComboPicker from 'oderon-vue/cpts/pickers/ComboPicker'

export default {
  components: {
    ComboPicker
  },
  props: {
    label: { type: String, default: 'Estado Baixa' },
    orientation: { type: String, default: 'horizontal' },
    value: {}
  },
  data() {
    return {
      allItems: [
        { id: 'active', name: 'Ativos' },
        { id: 'lost', name: 'Extraviados' },
        { id: 'scrap', name: 'Sucata' },
        { id: 'obsolete', name: 'Obsoletos' }
      ]
    }
  }
}
</script>

<style></style>
